import $ from 'jquery';

const upcomingEventsInit = ($eventsEl, location) => {
    const $tileList = $eventsEl.find('.js-tile-list');
    $tileList.html('');
    $eventsEl.find('.js-tile-source .c-event-tile').clone().appendTo($tileList);

    const $eventTile = $eventsEl.find('.js-tile-list .c-event-tile');

    // Init location value
    $eventsEl.find('.opted-location p').text(location);

    $eventTile.each(function () {
        // lowercase all the string value to minimize risk of unmatch value setup
        const dataValue = $(this).data('event').toLowerCase();
        const locationValue = location.toLowerCase();

        if (dataValue !== locationValue) {
            $(this).remove();
        }
    });
};

const showEventListing = ($upcomingEventsEl, $eventLocation) => {
    const $optedEventLocation = $upcomingEventsEl.find('.opted-location p');

    $eventLocation.change(function () {
        const locationValue = $(this).val();

        // set selected value
        $optedEventLocation.text(locationValue);

        // filter event based on selected value
        upcomingEventsInit($upcomingEventsEl, locationValue);
    });
};

const cloneSource = $events => {
    $events.find('.event-lists')
        .addClass('js-tile-list').clone()
        .addClass('hide js-tile-source')
        .removeClass('js-tile-list')
        .appendTo($events.find('.container'));
};

$(() => {
    const $allEvents = $('.s-upcoming-events');

    if ($allEvents.length) {
        $allEvents.each(function () {
            const $events = $(this);

            const $eventLocationSelector = $events.find('select');
            const initLocationValue = $eventLocationSelector.val();

            cloneSource($events);
            upcomingEventsInit($events, initLocationValue);
            showEventListing($events, $eventLocationSelector);
        });
    }
});
